import { Breadcrumb, Button, Card, Popconfirm, Skeleton, Table } from "antd";
import React, { useEffect, useState } from "react";
import Dashboard from "../../Layout/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getStore, updateStore } from "../../../actions/store";
import { formatDate } from "../../../utils/Utils";

const ViewStore = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const store = useSelector((state) => state?.store)?.store;
  const storeInfo = useSelector((state) => state?.store)?.store?.storeInfo;
  const shippingInfo = useSelector((state) => state?.store)?.store
    ?.shippingInfo;
  const storeMembers = useSelector((state) => state?.store)?.store?.members;
  const storeOrders = useSelector((state) => state?.store)?.store?.orders;
  const [storeStatus, setStoreStatus] = useState(storeInfo?.storeStatus);

  useEffect(() => {
    setLoading(true);
    setLoadingButton(false);
    dispatch(getStore(id));
    setStoreStatus(storeInfo?.storeStatus);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [storeStatus]);

  const dispatch = useDispatch();

  const updateStoreStatus = () => {
    setLoadingButton(true);
    setStoreStatus();
    let formData = {
      storeStatus: storeStatus === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    };
    dispatch(updateStore(id, formData, setLoadingButton));
  };

  return (
    <Dashboard title="View Store" superAdmin>
      <div className="p-4 shadow bg-white mt-2 mb-6 flex items-center justify-between">
        <Breadcrumb>
          <Breadcrumb.Item>
            <a href="/stores">Stores</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{storeInfo?.name}</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <div>
        <div className="mt-5 bg-white shadow p-4">
          <Skeleton loading={loading}>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mb-4">
              <Card size="small">
                <div className="flex flex-col justify-center items-center">
                  <p className="text-xl m-0">{store?.members?.length}</p>
                  <p className="m-0">Total Members</p>
                </div>
              </Card>
              <Card size="small">
                <div className="flex flex-col justify-center items-center">
                  <p className="text-xl m-0">{store?.orders?.length}</p>
                  <p className="m-0">Total Orders</p>
                </div>
              </Card>
              <Card size="small">
                <div className="flex flex-col justify-center items-center">
                  <p className="text-xl m-0">
                    {store?.totalSales[0]?.totalsales
                      ? `${storeInfo?.currency} ${store?.totalSales[0]?.totalsales}`
                      : 0}
                  </p>
                  <p className="m-0">Total Sales</p>
                </div>
              </Card>
            </div>
          </Skeleton>
          <Skeleton loading={loading}>
            <div className="grid grid-cols-1 md:grid-cols-2  gap-4 mb-4">
              <Card size="small" title="Store Information">
                <p>Name: {storeInfo?.name}</p>
                <p>Country: {storeInfo?.country}</p>
                <p>Currency: {storeInfo?.currency}</p>
                <p>Created At: {formatDate(storeInfo?.createdAt)}</p>
                <p>Updated At: {formatDate(storeInfo?.updatedAt)}</p>
              </Card>
              <Card size="small" title="Store Shipping Information">
                {shippingInfo?.length > 0 ? (
                  <Table
                    scroll={{ x: 500 }}
                    dataSource={shippingInfo}
                    rowKey={(record) => record?._id}
                    columns={[
                      {
                        key: 1,
                        title: "Name",
                        dataIndex: "name",
                      },
                      {
                        key: 2,
                        title: "Value",
                        dataIndex: "value",
                      },
                      {
                        key: 3,
                        title: "Created At",
                        dataIndex: "createdAt",
                        render: (_, record) => (
                          <p>{formatDate(record?.createdAt)}</p>
                        ),
                      },
                      {
                        key: 4,
                        title: "Updated At",
                        dataIndex: "updatedAt",
                        render: (_, record) => (
                          <p>{formatDate(record?.updatedAt)}</p>
                        ),
                      },
                      {
                        key: 5,
                        title: "Description",
                        dataIndex: "description",
                      },
                    ]}
                  />
                ) : (
                  "No data found!"
                )}
              </Card>
            </div>
          </Skeleton>
          <Skeleton loading={loading}>
            <div className="grid grid-cols-1 md:grid-cols-2  gap-4 mb-4">
              <Card size="small" title="Store Members">
                {storeMembers?.length > 0 ? (
                  <Table
                    scroll={{ x: 500 }}
                    dataSource={storeMembers}
                    rowKey={(record) => record?._id}
                    columns={[
                      {
                        key: 1,
                        title: "Name",
                        dataIndex: "name",
                      },
                      {
                        key: 2,
                        title: "Email",
                        dataIndex: "email",
                      },
                      {
                        key: 3,
                        title: "Phone",
                        dataIndex: "phone",
                      },
                      {
                        key: 4,
                        title: "Created At",
                        dataIndex: "createdAt",
                        render: (_, record) => (
                          <p>{formatDate(record?.createdAt)}</p>
                        ),
                      },
                      {
                        key: 5,
                        title: "Updated At",
                        dataIndex: "updatedAt",
                        render: (_, record) => (
                          <p>{formatDate(record?.updatedAt)}</p>
                        ),
                      },
                      {
                        key: 6,
                        title: "Role",
                        dataIndex: "role",
                      },
                    ]}
                  />
                ) : (
                  "No data found!"
                )}
              </Card>
              <Card size="small" title="Store Orders">
                {storeOrders?.length > 0 ? (
                  <Table
                    scroll={{ x: 650 }}
                    dataSource={storeOrders}
                    rowKey={(record) => record?._id}
                    columns={[
                      {
                        key: 1,
                        title: "Order By",
                        render: (_, record) => record?.user?.name,
                      },
                      {
                        key: 2,
                        title: "Items",
                        render: (_, record) => record?.orderItems?.length,
                      },
                      {
                        key: 3,
                        title: "Status",
                        render: (record) => record?.status,
                      },
                      {
                        key: 4,
                        title: "Total",
                        render: (record) => (
                          <p className="m-0">
                            {storeInfo?.currency} {record?.totalPrice}
                          </p>
                        ),
                      },
                      {
                        key: 5,
                        title: "Created At",
                        dataIndex: "createdAt",
                        render: (_, record) => (
                          <p>{formatDate(record?.createdAt)}</p>
                        ),
                      },
                      {
                        key: 6,
                        title: "Updated At",
                        dataIndex: "updatedAt",
                        render: (_, record) => (
                          <p>{formatDate(record?.updatedAt)}</p>
                        ),
                      },
                    ]}
                  />
                ) : (
                  "No data found!"
                )}
              </Card>
            </div>
          </Skeleton>
          <Skeleton loading={loading}>
            <div className="flex justify-center my-4 gap-4">
              <Button href="/stores">Cancel</Button>
              <Popconfirm
                title={`Are you sure to ${
                  storeStatus === "ACTIVE" ? `disable` : `enable`
                } this store?`}
                onConfirm={updateStoreStatus}
                okText="Yes"
                cancelText="No"
              >
                {storeStatus === "ACTIVE" ? (
                  <Button danger type="primary" loading={loadingButton}>
                    Disable Store
                  </Button>
                ) : (
                  <Button type="primary" loading={loadingButton}>
                    Enable Store
                  </Button>
                )}
              </Popconfirm>
            </div>
          </Skeleton>
        </div>
      </div>
    </Dashboard>
  );
};

export default ViewStore;
